import posthog from 'posthog-js'
import * as Sentry from '@sentry/nextjs'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
	api_host: '/relay-GTZD',
	defaults: '2025-05-24',
})

console.log('pro', process.env)

Sentry.init({
	dsn: 'https://edfcdeb69f9ec242f5fcef72bbd6132a@o369466.ingest.us.sentry.io/4507175336411136',
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	integrations: [],
})
